import { toast } from 'react-toastify'
import axios from '../../Axios'
import { Urls } from '../../Urls'
import transport_alt from '../../Content/images/transporter_logo.png'
export const validateInputs = (origin, inputOrigin, destination, inputDestination, transitTime = '', show = true) => {
    const showToast = (message = '', show = true) => {
        return show ?
            toast.error(message) :
            ''
    }
    if(!inputOrigin || !inputDestination || !origin || !destination)
    return 0
    if (inputOrigin.trim() !== origin.location_name.trim()) {
        showToast('Please Select Destination From Dropdown', show)
        return 0;
    }
    if (inputDestination.trim() !== destination.location_name.trim()) {
        showToast('Please Select Destination From Dropdown', show);
        return 0;
    }
    if (inputOrigin.trim().length === 0 || inputDestination.trim().length === 0) {
        showToast('Please Select Origin & Destinations From Dropdown Only', show);
        return 0;
    }
    if (inputOrigin.trim() === inputDestination.trim()) {
        showToast('Origin and Destination cannot be Same', show);
        return 0;
    }
    if (transitTime.length !== 0) {
        var rgx = /^[0-9]*\.?[0-9]*$/;
        if (!transitTime.match(rgx)) {
            showToast("Please Enter Number only in Transit Time", show);
            return 0;
        }
        return 1;
    }
    return 1;
}
export const excludeAllLocations = (inputOrigin, inputDestination) => {
    return inputOrigin === 'ALL' || inputDestination === 'ALL'
}
export const getRequestData = (origin, inputOrigin, destination, inputDestination, filters = [],fieldlist = [], skip = 0, transitTime = '', preferredTruck = '', limit = 10) => {
    var industries = []
    var zones = []
    
    
    let request_data = { "filters": [], "skip": skip, "limit": limit, transit_time: transitTime, preferred_truck_type: preferredTruck }
    if (inputOrigin.trim() !== 'ALL') {
        request_data.filters.push(
            {
                "filter": "origin",
                "type": "coordinates",
                "value": [origin.location.lon, origin.location.lat],
                "label":origin.location.label || origin.location_name,
                "isChecked": false
            },
        )
    }
    if (inputDestination.trim() !== 'ALL') {
        request_data.filters.push(
            {
                "filter": "destination",
                "type": "coordinates",
                "value": [destination.location.lon, destination.location.lat],
                "label":destination.location.label || destination.location_name,
                "isChecked": false
            },
        )
    }
    filters.map(item => {
        request_data.filters.push({
            "count": item.count,
            "filter": item.filter,
            "isChecked": true,
            "type": item.type
        }
        )
    })
    if(fieldlist.length > 0 ){
        fieldlist.map(item =>{
            if(item.field === 'industry'){
                industries.push(item.value)
            }
            if(item.field === 'zones'){
                zones.push(item.value)
            }
        })
        request_data.filters.push(
            {"filter":"fields",
            "value":[{
                "based" : "industry_served.name",
                "value" : industries
            },
            {
            "based" : "zones",
            "value" : zones
            }]
        })
    }
    return request_data;
}
export const AxiosRequest = (requestData) => {
    return axios.post(`${Urls.DiscoverNow}`, requestData)
}
export const ShortlistTransporter = async (transporter_id, transporter_name, currentShortlistValue) => {
    let request_data = {
        "shortlists": [
            {
                "transporter_id": transporter_id,
                "transporter_name": transporter_name
            }
        ]
    }
    return currentShortlistValue ?
        axios.delete(Urls.Transporters.Shortlist, {
            data: {
                "shortlists": [
                    {
                        "transporter_id": transporter_id,
                        "transporter_name": transporter_name
                    }
                ]
            }
        }) :
        axios.post(Urls.Transporters.Shortlist, request_data)
}
export const getImageSrc = (logo) => {
    if (logo)
        // return `https://lorrifilesproduction.blob.core.windows.net/public-container/${logo}`
        return `${Urls.showlogo}/${logo}`
    return transport_alt
}
export const valiData=(data,keyname)=>{
    if(data && data[keyname])
    return true
    return false
}
export const mapProcurementStatus = (status) => {
    switch (status) {
        case 'active': return 'ACTIVE'
        case 'pending': return 'APPROVAL PENDING'
        case 'approved': return 'APPROVED'
        case 'closed': return 'CLOSED'
        case 'disapproved': return 'DISAPPROVED'
        default: return
    }
}
export const localDateTime=(timestamp,date=true)=>{
    let dateobject=new Date(timestamp)
    return date?dateobject.toLocaleDateString():dateobject.toLocaleTimeString()
}
export const MatchValues=(selectedorigin,selecteddestination,availableorigin,availabledestination)=>{

    if(selectedorigin===availableorigin && selecteddestination===availabledestination)
    return true
    return false
}